export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/63be6d886170d40a9f7900a9c2ee1f30.png";